import { LookbookSettingsDelwinMenuItem } from '@app/components/lookbook/LookbookSettingsPage/components';
import { Option } from '@app/components/various/Fields/Select';
import { AutocompleteField, FormGrid } from '@app/components/various/Form';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { DeliveryWindow } from '@typings';
import { useTranslation } from 'react-i18next';

const getDelwinName = (value: string | number | null, deliveryWindows: DeliveryWindow.Mixed[]) => {
  const delwinName = deliveryWindows.find(delwin => delwin.deliveryWindow === value)?.name;

  if (!isDefined(delwinName) || isEmpty(delwinName)) {
    return '-';
  }

  return delwinName;
};

interface Props {
  fieldName: string;
  currentLookbookDeliveryWindows: DeliveryWindow.Mixed[];
  isLoading?: boolean;
}

export const LookbookSettingsDeliveryWindowsField = ({ fieldName, isLoading = false, currentLookbookDeliveryWindows }: Props) => {
  const { t } = useTranslation(['common']);

  const hasActiveDeliveryWindows = !isEmpty(currentLookbookDeliveryWindows);

  return (
    <FormGrid>
      <AutocompleteField
        name={fieldName}
        overflowContainer
        label={t('common:active_delivery_window')}
        placeholder={hasActiveDeliveryWindows ? '' : t('common:all')}
        renderPill={value => getDelwinName(value, currentLookbookDeliveryWindows)}
        isLoadingOptions={isLoading}
        isRequired
        showArrow={false}
        isDisabled
        isReadOnly
      >
        {currentLookbookDeliveryWindows.map(deliveryWindow => (
          <Option key={deliveryWindow.deliveryWindow} value={deliveryWindow.deliveryWindow}>
            <LookbookSettingsDelwinMenuItem deliveryWindow={deliveryWindow} />
          </Option>
        ))}
      </AutocompleteField>
    </FormGrid>
  );
};
